<template>
  <div>
    <div>
      <v-card class="mx-auto" max-width="1000" min-width="300">
        <v-toolbar class="pencil" :color="ToolColor" dark @click="Loadin();Hide = !Hide">
          <v-toolbar-title>{{ Headline }}</v-toolbar-title>

          <v-toolbar-side-icon color="white darken-1">
            <v-icon v-if="Hide == false" color="orange ligthen-1"
              >arrow_downward</v-icon
            >
            <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
          </v-toolbar-side-icon>

          <v-spacer></v-spacer>
        </v-toolbar>

        <v-expand-transition>
          <div v-if="Hide">
                <div>
      <v-flex justify="center">
        <Questions
          v-if="selectedStudent != null"
          :schoolId="schoolId"
          :id="id"
          v-model="dialog"
          :student="selectedStudent"
        />
        
      </v-flex>
    </div>
    <div class="bellowPen">
    <div v-if="NothingToShow==false && students!= null">

            <v-container grid-list-md>
              <h1>Ej påbörjade</h1>
              <v-layout row wrap>
                <v-flex v-for="(item, index) in students.Notstarted" md3 lg2 :key="item.name">
                                  <v-btn
                   @mouseover="NotDeadlines[index] = true;NotDeadlines = [...NotDeadlines];"
                    @mouseleave="NotDeadlines[index] = false;NotDeadlines = [...NotDeadlines];"
                  
                    class="mx-2"
                    dark
                    @click="
                      selectedStudent = item;
                      dialog = true; "
                    color="red darken-1"
                  >
                    {{
                     item.name
                    }}
                  </v-btn>
                  <v-progress-linear
                    color="red darken-3"
                    class="Conbutton"
                    :value="0"
                  ></v-progress-linear>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container grid-list-md>
              <h1>Pågående</h1>
              <v-layout row wrap>
                <v-flex v-for="(item, index) in students.Ongoing" md3 lg2 :key="item.name">
                  
                  <v-btn
                    @mouseover=" OngoingDeadlines[index] = true;OngoingDeadlines = [...OngoingDeadlines];"
                    @mouseleave="OngoingDeadlines[index] = false;OngoingDeadlines = [...OngoingDeadlines];"
                    class="mx-2"
                    dark
                    @click="
                      selectedStudent = item;
                      dialog = true;
                    "
                    color="amber ligthen-4"
                  >
                  
                    {{
                      OngoingDeadlines[index] ? locfun.getDate(item.deadline) : item.name
                    }}
                  </v-btn>
                  <v-progress-linear
                    color="amber ligthen-2"
                    class="Conbutton"
                    :value="item.step * 100"
                  ></v-progress-linear>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container grid-list-md>
              <h1>Avslutade</h1>
              <v-layout row wrap>
                <v-flex
                  v-for="(item, index) in students.Done"
                  md3
                  lg2
                  :key="item.name"
                >
                  <div
                    @mouseover=" DoneDeadlines[index] = true;DoneDeadlines = [...DoneDeadlines];"
                    @mouseleave="DoneDeadlines[index] = false;DoneDeadlines = [...DoneDeadlines];"
                  >
                    <v-btn
                      dark
                      @click="
                        selectedStudent = item;
                        selectedAnswers = [...item.answer];
                        dialog = true;
                      "
                      color="green ligthen-4"
                    >
                      {{
                        DoneDeadlines[index]
                          ? locfun.getDate( item.deadline)
                          : item.name
                      }}
                    </v-btn>
                    <v-progress-linear
                      color="green ligthen-2"
                      class="Conbutton"
                      :value="item.step * 100"
                    ></v-progress-linear>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
    </div>
    <div v-else  :class="ToolColor+ ' lighten-2 text-center'">  
    <span class="tt" color="white">Det finns inga kartläggningar att fylla i just nu.</span>
    
    </div>
          </div>
          </div>
        </v-expand-transition>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import fun from "../functions";
import Questions from "./Questions";

export default {
  components: { Questions },
  props: {
    schoolId: String,
    id: String,
    Headline: String,
    ToolColor: String,
  },
  computed: {
    ...mapGetters('mappings', ['Mappings','mappingsFetched']),
    ...mapGetters('classesAP', ['classes']),

students(){

          let Done=[]
  let Ongoing=[]
  let Notstarted=[]
    if (this.mappingsFetched==true) {

  this.Mappings.forEach(Map => {
if (Map.answerId.length==0) {
   Notstarted.push(Map)
}
else{


    let AID = Map.answerId.findIndex(M=> M==this.id)
  //  (Map)
  //  (Map.answerId.findIndex(this.id))
    if (AID==-1) {
      Notstarted.push(Map)
    }
    else
    {
      
  Map.step=Map.answer[AID].step;
      if (Map.answer[AID].step==1) {
        Done.push(Map)
      }
      else
      {
        Ongoing.push(Map)
      }


    }
  
    }
  });

  let DoneDeadlines= []
  let OngoingDeadlines= []
  let NotDeadlines= []
     Done.forEach((stud) => {
     DoneDeadlines.push(false);
    });
         Ongoing.forEach((stud) => {
      OngoingDeadlines.push(false);
    });

         Notstarted.forEach((stud) => {
      NotDeadlines.push(false);
    })
   this.DoneDeadlines=DoneDeadlines;
   this.OngoingDeadlines=OngoingDeadlines;
   this.NotDeadlines=NotDeadlines;
if(Done.length+Ongoing.length+Notstarted.length==0)
{
this.NothingToShow=true

}

let output= {Done: Done, Ongoing:Ongoing, Notstarted: Notstarted}
//  (output)
  return output;
    }
},

  },
  created() {
    this.locfun = new fun();
 
  },
  methods: {
    ...mapActions("mappings", ["initMappingsforMe"]),

    Loadin()
    {
    if (this.mappingsFetched==false) {
      //console.log("Fetched");
      if(this.classes.map(CL=> CL.id).length!=0)   
      this.initMappingsforMe({id:this.classes.map(CL=> CL.id)  , schoolId:this.schoolId})
}  
    },

   },
  data() {
    return {
      test: false,
      deadline: 1623619888248,

      OngoingDeadlines:[],
      NotDeadlines:[],
      DoneDeadlines:[],
      selectedStudent: null,
      selectedAnswers: [],
      Hide: false,
      NothingToShow:false,
      dialog: false,
    };
  },
};
</script>

<style scoped>
.Conbutton {
  margin-top: 0%;
  width: 55%;
  margin-left: 3.5%;
}


</style>